import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_COMMON from "./KAMPYLE_COMMON";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_EVENT_DISPATCHER from "./KAMPYLE_EVENT_DISPATCHER";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import KAMPYLE_VIEW from "./KAMPYLE_VIEW";
import MDIGITAL_EMBEDDED from "./MDIGITAL_EMBEDDED";

  function init() {
    var eventMapping = {
      neb_loadForm: [createEmbeddedIframe],
      neb_formLoaded: [showForm],
      neb_iFrameHeightChanged: [calculateFormSize],
      neb_formClosed: [handleFormClosed],
      MDigital_ThankYou_Displayed: [handleThankyouPage],
      neb_targetingInit: [removeEmbeddedIFrames],
    };
    KAMPYLE_EVENT_DISPATCHER.subscribeMany(eventMapping);
  }

  function removeEmbeddedIFrames() {
    if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.CLEAR_EMBEDDED_ON_UPDATE_PAGE)) {
      var allForms = KAMPYLE_DATA.getAllForms();
      for (var i = 0; i < allForms.length; i++) {
        var form = allForms[i];
        if (KAMPYLE_DATA.isEmbeddedDisplayType(form.formId)) {
          MDIGITAL_EMBEDDED.deleteEmbeddedIframe(form.formId);
        }
      }
    }
  }

	function isEmbeddedFullWidth(formId){
    var formData = KAMPYLE_DATA.getFormData(formId);
    return KAMPYLE_UTILS.getNestedPropertyValue(formData, 'isFullWidthEmbedded');
  }

  function createEmbeddedIframe(eventName, data) {
		data = data || {};
		if (!KAMPYLE_DATA.isEmbeddedDisplayType(data.formId)) { return false; }

		var hostingElement = getHostingElement(data.formId);

		if (!isHostingElementValid(hostingElement)) { return false; }

		if (hostingElement) {
      var hostingElementHeight = parseInt(getComputedStyle(hostingElement).height);
      var hostingElementPaddingY = parseInt(getComputedStyle(hostingElement).paddingTop) + parseInt(getComputedStyle(hostingElement).paddingBottom);
      if(hostingElementPaddingY === hostingElementHeight) {
        hostingElementHeight  = 0;
      }
      addHostingElementHeight(hostingElement.id, hostingElementHeight);
		}

    var timeoutHandler = setTimeout(function () {
      if (!KAMPYLE_FUNC.isFormLoaded(data.formId)) {
        KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.NEB_FORM_LOADING_HAS_FAILED,
          {
            formId: data.formId,
            failureCause: KAMPYLE_CONSTANT.FORM_LOADING_FAILURE_CAUSE.APPLICATION_FAILED,
            formState: KAMPYLE_DATA.getFormState(data.formId)
          })
      }
    }, KAMPYLE_CONSTANT.NETWORK.TIME_FOR_FORM_TO_LOAD_MS);
    KAMPYLE_DATA.setTimeoutHandler(KAMPYLE_CONSTANT.TIMEOUT_HANDLERS.EMBEDDED_STATUS + "_" + data.formId, timeoutHandler);

		var formIframe = getOrCreateIframe(data.formId);
		var formData = KAMPYLE_DATA.getFormData(data.formId);
		formIframe.src = KAMPYLE_COMMON.createFormUrl(formData.formHtmlUrl, data.formId);
		hostingElement.appendChild(formIframe);
		KAMPYLE_DATA.setFormState(data.formId, { shouldBeShown: true });
    return true;
	}

	function showForm (eventName, data){
    if (!KAMPYLE_DATA.isEmbeddedDisplayType(data.formId) || KAMPYLE_FUNC.hasApplicationLoadingFailed(data.formId)) { return false; }

		var currIframe = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.EMBEDDED.IFRAME_ID_PREFIX + data.formId);
		if (!!currIframe) {
			setIframeStyle(currIframe, {display:'block'});
		}
		return true;
	}

	// region validation
	function isHostingElementValid(element) {
		return 	element !== null &&
						(!element.innerHTML ||
						(typeof element.innerHTML === 'string' && element.innerHTML.trim() === ""));
	}
	// endregion

  function getHostingElement(formId) {
    var formData = KAMPYLE_DATA.getFormData(formId);
    return document.getElementById(KAMPYLE_UTILS.getNestedPropertyValue(formData, 'embeddedData.pageElementId'));
  }

  function shouldCustomizeScrolling(formId) {
    var isPreventIFrameScrollFlickeringEnabled = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.PREVENT_IFRAME_SCROLLBAR_FLICKERING);
    var isFormV2 = KAMPYLE_DATA.isV2Form(formId);
    var isCustomHTML = KAMPYLE_DATA.isCustomHtmlForm(formId);
    return (
      isPreventIFrameScrollFlickeringEnabled &&
      !isFormV2 &&
      !isCustomHTML
    )
  }

  function getOrCreateIframe(formId) {
    var iframeId = KAMPYLE_CONSTANT.IFRAME_SETTINGS.EMBEDDED.IFRAME_ID_PREFIX + formId;
    var formIframe = document.getElementById(iframeId);
    if (!formIframe) {

      formIframe = document.createElement('iframe');
      formIframe.id = iframeId;
      formIframe.setAttribute('title', KAMPYLE_CONSTANT.IFRAME_SETTINGS.IFRAME_TITLE); //WCAG

      if (shouldCustomizeScrolling(formId)) {
        formIframe.setAttribute('scrolling', 'no'); //to remove initial flash/flicker of scrollbar
      }

      setIframeStyle(formIframe, { display: 'none' })

    }
    return formIframe;
  }

  function setIframeStyle(formIframe, style) {
    var defaultStyle = {
      border: 0,
      width: '100%',
      height: '100%'
    };

    var formattedStyle = Object.assign({}, defaultStyle, style);

    KAMPYLE_UTILS.setElementStyle(formIframe, formattedStyle, false /* force !important */);

  }

  function setIframeScrolling(iframe, enableScroll) {
    if (!enableScroll) {
      KAMPYLE_UTILS.addAttributesOnElement(iframe, {
        scrolling: "no"
      });
    }
    else {
      //default without scrolling attribute - scrolling is enabled
      KAMPYLE_UTILS.removeAttribute(iframe, "scrolling");
    }
  }

	// region responsiveness
	function calculateFormSize(event,data){
		data = data || {};
		var formData = KAMPYLE_DATA.getFormData(data.formId) || {};
		var hostingElement = getHostingElement(data.formId);
		var formIframe = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.EMBEDDED.IFRAME_ID_PREFIX + data.formId);

		if (!KAMPYLE_DATA.isEmbeddedDisplayType(data.formId) || hostingElement === null || formIframe === null) {
			return false;
		}

		// new settings
		var newHeightSettings = calculateHeights(hostingElement, formData, data);
		var newWidth = calculateWidth(hostingElement, formData);
		var iframeStyle = {
			height : newHeightSettings.iframeHeight + 'px',
			width : isEmbeddedFullWidth(data.formId) ? '100%' : newWidth + 'px'
		}
		setIframeStyle(formIframe, iframeStyle);
		
		if (shouldCustomizeScrolling(data.formId)) {
			setIframeScrolling(formIframe, newHeightSettings.shouldBeStatic);
		}

		var messageData = {height: newHeightSettings.formHeight, width: newWidth, shouldBeStatic: newHeightSettings.shouldBeStatic};
		KAMPYLE_UTILS.sendMessageToIframe(KAMPYLE_CONSTANT.IFRAME_SETTINGS.EMBEDDED.IFRAME_ID_PREFIX + data.formId, {
			action: 'setFormStyle',
			data: messageData,
		});
		return messageData;
	}

	function calculateHeights(hostingElement,formData, data){
		// Form settings
		var isStatic = formData.isFixedSize === 'true' || formData.isFixedSize === true;
		var shouldBeStatic = isStatic;
		var formHeight = isStatic ? parseInt(formData.formHeight) : data.newHeight;

		// Host element settings
		var hostingElementComputedStyle = getComputedStyle(hostingElement);
    var hostHeight = getHostingElementHeight(hostingElement.id);
    hostHeight = isNaN(hostHeight) ? parseInt(hostingElement.style.height || 0) : hostHeight;

		var hostMaxHeight = isNaN(parseInt(hostingElementComputedStyle.maxHeight)) ? (hostHeight || 0) : parseInt(hostingElementComputedStyle.maxHeight);
		var hostMinHeight = isNaN(parseInt(hostingElementComputedStyle.minHeight)) ? 0 : parseInt(hostingElementComputedStyle.minHeight);
		var isDynamicHost = hostMaxHeight === 0 && hostMinHeight === 0;

		// In case the customer defined min > max
		if(hostMaxHeight !== 0 && hostMinHeight > hostMaxHeight){
			hostMaxHeight = hostMinHeight;
		}

		return getNewHeightSettings(formHeight, shouldBeStatic, isDynamicHost, hostMaxHeight , hostMinHeight, hostHeight);
	}

	function getNewHeightSettings(formHeight, shouldBeStatic, isDynamicHost, hostMaxHeight , hostMinHeight, hostHeight ){
		var newIframeHeight;
		var newFormHeight = formHeight;

		if (isDynamicHost){
			newFormHeight  = formHeight;
			newIframeHeight = newFormHeight;
		}
		else {
			// In case the form is higher then the host
			if (hostMaxHeight !== 0 && formHeight >= hostMaxHeight) {
				newFormHeight = hostMaxHeight;
				shouldBeStatic = true;
			}
			newIframeHeight = newFormHeight;

			// In case the form is shorter, we want a space between the form and the host
			if (formHeight < hostMinHeight || formHeight < hostHeight) {
				newIframeHeight = hostMinHeight !== 0 ? hostMinHeight : hostHeight;
			}
		}

		return {formHeight : newFormHeight, iframeHeight: newIframeHeight, shouldBeStatic: shouldBeStatic}
	}

	function calculateWidth(hostingElement, formData){
		var formWidth = parseInt(formData.formWidth);

		return Math.min(formWidth, KAMPYLE_UTILS.getElementSize(hostingElement).width);
	}
	//endregion

  function handleFormClosed(eventName, data) {
    MDIGITAL_EMBEDDED.deleteEmbeddedIframe(data.formId);
  }

  function deleteEmbeddedIframe(formId){
    if (!KAMPYLE_DATA.isEmbeddedDisplayType(formId)) { return false; }
    var currIframe = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.EMBEDDED.IFRAME_ID_PREFIX + formId);
    if(currIframe === null) {
    	return false;
    }
    KAMPYLE_UTILS.removeAllContent(currIframe);
    return true;
  }

  function addHostingElementHeight(elementId, height) {
    var elementsHeightsObj = KAMPYLE_DATA.getMemoryData('hostingElementsHeights');
    elementsHeightsObj[elementId] = height;
    KAMPYLE_DATA.setMemoryData('hostingElementsHeights', elementsHeightsObj);
  }

  function getHostingElementHeight(elementId) {
    return KAMPYLE_DATA.getMemoryData('hostingElementsHeights')[elementId] || 0;
  }

	function handleThankyouPage(eventName, data){
		data = data || {};
		if (KAMPYLE_DATA.isEmbeddedDisplayType(data.formId) && KAMPYLE_DATA.isMobile()){
			KAMPYLE_VIEW.scrollToEmbeddedForm(data.formId);
		}
	}

  export default {
    //test
    removeEmbeddedIFrames: removeEmbeddedIFrames,
    //Public API
    init: init,
    createEmbeddedIframe: createEmbeddedIframe,
    showForm: showForm,
    calculateFormSize: calculateFormSize,
    deleteEmbeddedIframe: deleteEmbeddedIframe,
    addHostingElementHeight: addHostingElementHeight,
    getHostingElementHeight: getHostingElementHeight,
    handleThankyouPage: handleThankyouPage,
    setIframeScrolling: setIframeScrolling
  };